import {H3Text, H6Text} from '@buncha/components/core/text';
import React, {memo} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {B2BUserScreens} from '@buncha/B2B/navigation/types';
import {Box} from '@buncha/components/core/view';
import FoodFam from '@buncha/components/core/icon/FoodFam';
import {Modules} from '@buncha/utils/types';
import {StyleSheet} from 'react-native';
import moment from 'moment';
import {useGetLocale} from '@buncha/localization/hooks';

interface Props {
  orderId: string;
  deliveryDate: string;
  dropOffTimeString: string;
}

const OrderRescheduleSuccess = (props: Props) => {
  const muli = useFontTheme('muli');
  const mortise = useFontTheme('mortise');
  const theme = useColorThemeType();
  const {orderId, deliveryDate, dropOffTimeString} = props;
  const {title, body} =
    useGetLocale(Modules.B2BUserOrder, B2BUserScreens.Reschedule) ?? {};
  const day = deliveryDate ? moment(deliveryDate).format('MMMM DD') : '';

  return (
    <Box style={styles.parent}>
      <FoodFam />
      <H3Text
        style={[
          styles.orderIdText,
          {
            fontFamily: mortise[700].normal,
            color: theme?.text.blue[300],
          },
        ]}>
        {title?.orderUpdated?.replace('{orderId}', orderId)}
      </H3Text>
      <H6Text
        style={[
          styles.orderDateText,
          {
            fontFamily: muli[400].normal,
            color: theme?.text.blue[300],
          },
        ]}>
        {body?.orderRescheduled?.[0]}
        <H6Text
          style={{
            fontFamily: muli[900].normal,
            color: theme?.text.blue[300],
          }}>
          {body?.orderRescheduled?.[1]
            ?.replace('{date}', day)
            ?.replace('{time}', dropOffTimeString)}
        </H6Text>
      </H6Text>
      <H6Text
        style={[
          styles.footerText,
          {
            fontFamily: muli[400].normal,
            color: theme?.text.blue[300],
          },
        ]}>
        {body?.seeYouSoon}
      </H6Text>
    </Box>
  );
};

export default memo(OrderRescheduleSuccess);

const styles = StyleSheet.create({
  parent: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 22,
  },
  orderIdText: {
    marginTop: 12,
  },
  orderDateText: {
    marginTop: 12,
  },
  footerText: {
    marginTop: 6,
  },
});
